// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SaveButton: 'save-button',
	CondoPrimaryCheckbox: 'condo-primary-checkbox',
	ApplyHstCheckbox: 'apply-hst-checkbox',
	Pin: 'pin',
	UnitNo: 'unit-no',
	LevelNo: 'level-no',
	Lot: 'lot',
	CondoPlan: 'condo-plan',
	CommonExpenses: 'common-expenses',
	UnitTypeSelect: 'unit-type-select',
	LegalDescriptionTextArea: 'legal-description-text-area',
	Option: 'option',
	SyncLegalDescriptionDiv: 'sync-legal-description-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
